module.exports = __webpack_public_path__ + "img/DPCM.2b88d37c.png";